module.exports = "/_next/static/images/main-3-85d2e17814783802a625982479057a05.webp";